import { notification } from "antd";
import instance from "./base-url";

import { useQuery, useMutation, useQueryClient } from 'react-query';

//Operation API
const getWorkshopByEvent = async (eventId) => await instance.get(`/api/Events?eventId=${eventId}`);

const getQuizByEvent = async (eventId) => await instance.get(`/api/Quizs?eventId=${eventId}`);

const getQuizs = async () => await instance.get(`/api/Quizs`);

export const getQuizQuestions = async (quizId) => await instance.get(`/api/QuizQuestions/getQuizQuestionsbyQuizid?quizid=${quizId}`);

export const getQuestionwithAnswers = async (questionId) => await instance.get(`/api/QuizAnswers/getQuizAnswerByQuestionId?id=${questionId}`);

const getParticipantByPhone = async (phoneNumber) => await instance.get(`/api/Participants/getallparticipants?phoneNumber=${phoneNumber}`);

const getBanks = async () => await instance.get(`api/Banks/ismobilemoney/false`);

const getMoMoProviders = async () => await instance.get(`api/Banks/ismobilemoney/true`);

const getInstitutions = async () => await instance.get(`/api/Institutions`);

const getEvents = async () => await instance.get(`/api/Events`);

const getEventsById = async (eventId) => await instance.get(`/api/Events/${eventId}`);

const getLocationById = async (locId) => await instance.get(`/api/Locations/${locId}`);

const getBankBranchesByCode = async (bankCode) => await instance.get(`/api/Banks/getbankbranchbybankCode/${bankCode}`);


const saveParticipant = async (payload) => await instance.post(`/api/Participants`, payload);

const updateParticipant = async ({participantId, payload}) => await instance.put(`/api/Participants/${participantId}`, payload);

const saveParticipantWorkshop = async (payload) => await instance.post(`/api/ParticipantEventRegistrations`, payload);

const saveQuizResult = async (payload) => await instance.post(`/api/QuizSubmissions`, payload);

//Operation Queries
export function useGetWorkshopByEvent(eventId) {
    return useQuery('getWorkshopByEvent', () => getWorkshopByEvent(eventId));
}

export function useGetQuizByEvent(eventId) {
    return useQuery(['getQuizByEvent', eventId], 
        getQuizByEvent(eventId), {enabled: !!eventId});
}

export function useGetQuizs() {
    return useQuery('getQuizs', getQuizs);
}

export function useGetQuizQuestions(quizId) {
    return useQuery('getQuizQuestions', () => getQuizQuestions(quizId));
}

export function useGetQuestionwithAnswers(questionId) {
    return useQuery('getQuestionwithAnswers', () => getQuestionwithAnswers(questionId));
}

export function useGetParticipantByPhone(phoneNumber) {
    return useQuery(['getParticipantByPhone', phoneNumber], 
        () => getParticipantByPhone(phoneNumber),
            {enabled: !!phoneNumber}
        );
}

export function useGetBanks() {
    return useQuery('getBanks', () => getBanks());
}

export function useGetMoMoProviders() {
    return useQuery('getMoMoProviders', () => getMoMoProviders());
}

export function useGetInstitutions() {
    return useQuery('getInstitutions', () => getInstitutions());
}

export function useGetEvents() {
    return useQuery('getEvents', () => getEvents());
}

export function useGetEventsById(eventId) {
    return useQuery(['getEventsById', eventId], 
        () => getEventsById(eventId), {enabled: !!eventId});
}


export function useGetLocationById(locId) {
    return useQuery(['getLocationById', locId], 
        () => getLocationById(locId), {enabled: !!locId});
}

export function useGetBankBranchesByCode(bankCode) {
    return useQuery(['getBankBranchesByCode', bankCode], 
        () => getBankBranchesByCode(bankCode), {enabled: !!bankCode});
}


export function useSaveParticipantWorkshop() {
    return useMutation(saveParticipantWorkshop,);
}

export function useSaveParticipant() {
    const queryClient = useQueryClient();

    return useMutation(saveParticipant, {
        onSuccess: () => {
           // notification.success({message: "Details sved successfully ..."});
        },
        onError: () => {
            notification.error({message:"Registering participant failed..."})
        }
    });
}

export function useUpdateParticipant() {
    const queryClient = useQueryClient();

    return useMutation(updateParticipant, {
        onSuccess: () => {
            // notification.success({message: "Details updated successfully..."});
        },
        onError: () => {
            notification.error({message: "Error saving participant..."});
        }
    });
}

export function useSaveQuizResult() {

    return useMutation(saveQuizResult, {
        onSuccess: () => {
            notification.success({message: "Quiz submitted successfully..."});
        },
        onError: () => {
            // notification.error({message: "Error submitting quiz..."});
            notification.success({message: "Quiz submitted successfully..."});
        }
    });
}
